
import { RevRating } from '@ds/components/Rating'
import { IconQuality } from '@ds/icons/IconQuality'

import translations from './RateSection.translations'

export default {
  components: {
    IconQuality,
    RevRating,
  },
  props: {
    globalRate: {
      type: Number,
      required: true,
    },
    totalReviews: {
      type: Number,
      required: true,
    },
  },
  computed: {
    translations: () => translations,
  },
}
